import { createSlice } from '@reduxjs/toolkit';
const lastContactedDatesSlice = createSlice({
  name: 'lastContactedDates',
  initialState: [],
  reducers: {
    addLastContactedDate: (state, action) => {
      state.push(action.payload);
    },
    setLastContactedDates: (state, action) => {
      return action.payload;
    },
  },
});

export const { addLastContactedDate, removeLastContactedDate, setLastContactedDates } = lastContactedDatesSlice.actions;
export default lastContactedDatesSlice.reducer;
